<template>
  <TooltipPortal>
    <TooltipContent
      :side="props.side ?? 'top'"
      :align="props.align"
      :class="[
        $style.content,
        `z-50 break-words rounded-md border-border bg-gray-800 p-2.5 text-center text-sm text-white shadow-lg dark:border dark:bg-sidebar`,
        props.size === 'xs' && 'text-xs',
        props.widthClass ?? `min-w-32 max-w-48`,
      ]"
      :collision-padding="10"
    >
      <slot></slot>

      <!-- Doesn't look great on dark mode when we have borders -->
      <TooltipArrow class="fill-gray-800 dark:fill-transparent" :width="8" />
    </TooltipContent>
  </TooltipPortal>
</template>

<script setup lang="ts">
import { TooltipArrow, TooltipContent, TooltipPortal } from "reka-ui";

const props = defineProps<{
  widthClass?: string;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  size?: "xs";
}>();
</script>

<style module>
.content {
  transform-origin: var(--reka-tooltip-content-transform-origin);

  @media (prefers-reduced-motion: no-preference) {
    &[data-state="instant-open"] :global,
    &[data-state="delayed-open"] :global {
      animation: pop-in 250ms var(--motion-timing-ease);
    }
    &[data-state="closed"] :global {
      animation: pop-out 250ms var(--motion-timing-ease);
    }
  }
}
</style>
